import { ReactElement } from 'react';
import { BaseLayout } from '../components/layout';
import { MobileNavItem } from '../components/layout/BaseLayout';
import { PasswordAssistContainer } from '../components/password-assist';

const PasswordAssist = (): ReactElement => {
  return (
    <BaseLayout
      className="login"
      mobileNav={{ type: MobileNavItem.ONLY_LOGO }}
      desktopNav="ONLY_TITLE"
    >
      <PasswordAssistContainer />
    </BaseLayout>
  );
};

export default PasswordAssist;
